import { flow, fromPairs, map, identity } from 'lodash/fp';

export default (encodeKey = identity) =>
  flow(
    map((value) => [encodeKey(value), true]),
    fromPairs,
  );
